import React, { useEffect, useState } from "react";
import {
  Routes,
  Route,
  NavLink,
  useNavigate,
  Navigate,
  Outlet,
} from "react-router-dom";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import { CookiesProvider, useCookies } from "react-cookie";
import Login from "../pages/Login/Login";
import Layout from "../pages/layout/Layout";

export const AuthContext = React.createContext(null);
const useAuth = () => {
  return React.useContext(AuthContext);
};
export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();

  const [token, setToken] = useState(localStorage.getItem("token") || "");
  const [name, setName] = useState(localStorage.getItem("name") || "");
  // const [cookies, setCookie, removeCookie] = useCookies(["token"]);

  const handleLogin = async (...props) => {
    try {
      const res = await props;

      localStorage.setItem("token", res[0]);
      localStorage.setItem("name", res[1]);

      // setCookie("token", token, { path: "/" });
      // setCookie("name", name, { path: "/" });
      toast.success("با موفقیت وارد شدید!");
      setTimeout(() => {
        navigate("/");
      }, 10);
    } catch (err) {
      console.error(err);
    }
  };

  function handleLogout() {
    // removeCookie("token", { path: "/" });
    // removeCookie("name", { path: "/" });
    localStorage.removeItem("token");
    localStorage.removeItem("name");
    toast.success("با موفقیت خارج شدید!");
    navigate("/login");
  }
  // useEffect(() => {
  //   const token = Cookies.get("token");
  //   const name = Cookies.get("name");
  //   setToken(token);
  //   setName(name);
  // });
  const value = {
    token,
    name,
    onLogin: handleLogin,
    onLogout: handleLogout,
    useAuth,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const ProtectedRoute = ({ children }) => {
  const [tokener, setTokener] = useState(localStorage.getItem("token"));
  const navigate = useNavigate();

  useEffect(() => {
    if (!tokener) {
      navigate("/login");
    }
  }, [tokener]);

  if (tokener) {
    return (
      <Layout>
        <Outlet />
      </Layout>
    );
  } else {
    return <Login />;
  }
};

export const NotOpenLogin = ({ children }) => {
  const [tokener, setTokener] = useState(localStorage.getItem("token"));

  const navigate = useNavigate();

  useEffect(() => {
    if (tokener) {
      navigate("/");
    }
  }, [tokener]);

  if (!tokener) return <Outlet />;

  return children;
};
